export function dataAttributesFalse(attrs?: string[]): string {
    return '';
}

export function dataAttributesForInactiveElement(): string {
    return '';
}
